export const json = {
  locale: 'ru_ru',
  recipe: "Рецепт",
  machine: "Машина",
  task: {
    state: {
      unset: "Не установлено",
      todo: "К выполнению",
      in_progress: "В процессе",
      to_test: "На тестирование",
      wont_fix: "Не будет исправлено",
      done: "Выполнено",
      paused: "Приостановлено",
    },
    priority: {
      unset: "Без приоритета",
      low: "Низкий",
      normal: "Обычный",
      high: "Высокий",
      max: "Срочный",
    },
    table: {
      header: {
        title: "Задача",
        state: "Статус",
        priority: "Приоритет",
        labels: "Метки",
      },
      placeholder: {
        filter: {
          priority: "Фильтровать электронные письма...",
        },
      },
      "no-results": "Нет результатов",
    },
    add: {
      title: "Добавить новую задачу",
      name: "Название задачи",
      name_placeholder: "Введите название задачи",
      priority: "Приоритет",
      title_translations: "Переводы заголовка",
      description_translations: "Переводы описания",
      icon_url: "URL иконки (опционально)",
      icon_url_placeholder: "Введите URL иконки",
      labels: "Метки",
      assigned_to: "Назначено",
      assigned_to_placeholder: "Выберите модератора",
      submit: "Создать задачу",
      cancel: "Отмена",
      edit_translations: "Редактировать переводы",
      save_translations: "Сохранить переводы",
      required_field: "Это поле обязательно",
      en_us_required: "Перевод на английский (США) обязателен",
      success: "Задача успешно создана!",
      error: "Ошибка при создании задачи. Пожалуйста, попробуйте снова.",
    },
  },
  table: {
    select: {
      of: "из",
      rows: "строк выбрано.",
    },
  },
  cookies: {
    link: 'Политика использования файлов cookie',
    title: "Согласие на использование файлов cookie",
    description:
      "Этот веб-сайт использует файлы cookie для обеспечения правильной работы и улучшения вашего опыта. Пожалуйста, выберите, какие файлы cookie вы разрешаете нам использовать.",
    policy_link: "Узнайте больше в нашей Политике использования файлов cookie",
    accept_all: "Принять все",
    accept_selected: "Принять выбранные",
    accept_essential: "Только необходимые",
    manage: "Управление настройками",
    save: "Сохранить настройки",
    back: "Назад",
    categories: {
      essential: {
        title: "Необходимые файлы cookie",
        description: "Эти файлы cookie необходимы для функционирования веб-сайта и не могут быть отключены.",
      },
      functional: {
        title: "Функциональные файлы cookie",
        description: "Эти файлы cookie позволяют использовать персонализированные функции и возможности.",
      },
      analytics: {
        title: "Аналитические файлы cookie",
        description: "Эти файлы cookie помогают нам понять, как посетители взаимодействуют с веб-сайтом.",
      },
      marketing: {
        title: "Маркетинговые файлы cookie",
        description: "Эти файлы cookie используются для отслеживания посетителей на веб-сайтах в рекламных целях.",
      },
    },
    expiration: {
      title: "Срок действия файлов cookie",
      description: "Выберите, как долго будут сохраняться ваши настройки файлов cookie:",
      thirty_days: "30 дней",
      ninety_days: "90 дней",
      six_months: "6 месяцев",
      one_year: "1 год",
    },
    policy: {
      title: "Политика использования файлов cookie",
      introduction:
        "Эта Политика использования файлов cookie объясняет, как мы используем файлы cookie и аналогичные технологии для распознавания вас при посещении нашего веб-сайта. Она объясняет, что представляют собой эти технологии и почему мы их используем, а также ваши права на контроль нашего использования этих технологий.",
      what_are_cookies: "Что такое файлы cookie?",
      what_are_cookies_text:
        "Файлы cookie — это небольшие файлы данных, которые размещаются на вашем компьютере или мобильном устройстве при посещении веб-сайта. Файлы cookie широко используются владельцами веб-сайтов для обеспечения работы их веб-сайтов или для более эффективной работы, а также для предоставления отчетной информации.",
      how_we_use: "Как мы используем файлы cookie",
      how_we_use_text:
        "Мы используем файлы cookie по нескольким причинам. Некоторые файлы cookie необходимы по техническим причинам для работы нашего веб-сайта, и мы называем их 'необходимыми' или 'обязательными' файлами cookie. Другие файлы cookie позволяют нам отслеживать и направлять интересы наших пользователей для улучшения опыта на нашем веб-сайте. Третьи стороны предоставляют файлы cookie через наш веб-сайт для рекламы, аналитики и других целей.",
      types: "Типы файлов cookie, которые мы используем",
      managing: "Управление вашими файлами cookie",
      managing_text:
        "Вы можете настроить или изменить элементы управления вашего веб-браузера для принятия или отклонения файлов cookie. Если вы решите отклонить файлы cookie, вы все равно сможете использовать наш веб-сайт, хотя ваш доступ к некоторым функциям и областям нашего веб-сайта может быть ограничен. Поскольку способы, которыми вы можете отклонить файлы cookie через элементы управления вашего веб-браузера, различаются от браузера к браузеру, вам следует обратиться к меню справки вашего браузера для получения дополнительной информации.",
      third_party: "Сторонние файлы cookie",
      third_party_text:
        "Помимо наших собственных файлов cookie, мы также можем использовать различные сторонние файлы cookie для сообщения статистики использования веб-сайта, доставки рекламы на веб-сайте и через него и так далее.",
      updates: "Обновления этой Политики использования файлов cookie",
      updates_text:
        "Мы можем время от времени обновлять эту Политику использования файлов cookie, чтобы отразить, например, изменения в файлах cookie, которые мы используем, или по другим операционным, юридическим или нормативным причинам. Поэтому, пожалуйста, регулярно просматривайте эту Политику использования файлов cookie, чтобы быть в курсе нашего использования файлов cookie и связанных технологий.",
      purpose: "Назначение",
      essential_purpose:
        "Необходимы для правильного функционирования веб-сайта. Эти файлы cookie обеспечивают основные функции, такие как навигация по страницам и доступ к защищенным областям веб-сайта.",
      functional_purpose:
        "Позволяют веб-сайту запоминать выбор, который вы делаете (например, ваше имя пользователя, язык или регион, в котором вы находитесь), и предоставлять улучшенные, более персонализированные функции.",
      analytics_purpose:
        "Помогают нам понять, как посетители взаимодействуют с нашим веб-сайтом, собирая и сообщая информацию анонимно.",
      marketing_purpose:
        "Используются для отслеживания посетителей на веб-сайтах. Цель состоит в том, чтобы показывать рекламу, которая является релевантной и привлекательной для отдельного пользователя.",
      always_active: "Всегда активно",
      active: "Активно",
      inactive: "Неактивно",
      back_to_site: "Вернуться на сайт",
    },
  },
  sidebar: {
    platform: "Платформа",
    dashboard: "Панель управления",
    tasks: {
      title: "Задачи",
      add: "Добавить задачу"
    },
    analytics: "Аналитика",
    users: "Пользователи",
    settings: "Настройки",
    admin_panel: {
      title: "Панель администратора",
      mods: {
        title: "Модераторы",
        add: "Добавить модератора"
      },
      labels: {
        title: "Метки",
        add: "Добавить метку"
      },
      pending: "Ожидающие одобрения"
    },
    documentation: {
      title: "Документация",
      create: "Создать документацию"
    },
    search: "Поиск в документах..."
  },
  pages: {
    user: {
      tabs: {
        overview: {
          title: "Обзор",
          userInfo: "Информация о пользователе",
          userId: "ID пользователя",
          role: "Роль",
          memberSince: "Участник с"
        },
        tasks: {
          title: "Задачи",
          assigned: "Назначенные задачи",
          noTasks: "Пока нет назначенных задач."
        },
        activity: {
          title: "Активность",
          recent: "Недавняя активность",
          noActivity: "Нет недавней активности."
        },
        settings: {
          title: "Настройки",
          user: "Настройки пользователя",
          admin: "Настройки администратора для этого пользователя."
        }
      }
    },
    mods: {
      error: {
        unknownError: "Неизвестная ошибка"
      },
      access: {
        title: "Доступ запрещен",
        description: "У вас нет разрешения на доступ к этой странице."
      },
      add: {
        link: "Добавить новый мод",
        title: "Добавить новый мод",
        addDesc: "Создать новую запись мода",
        name: {
          title: "Название",
          placeholder: "Введите название мода"
        },
        description: {
          title: "Описание",
          placholder: "Введите описание на "
        },
        optional: "Опционально",
        versions: {
          title: "Версии",
          add: "Добавить версию"
        },
        icon: "URL иконки",
        launchers: "Лаунчеры",
        form: {
          errors: {
            alert: {
              title: "Ошибка",
              description: "Пожалуйста, исправьте ошибки выше перед отправкой."
            },
            name: "Название обязательно",
            description: "Описание на английском (США) обязательно",
            curseforge: "Ссылка на CurseForge обязательна",
            invalidURL: "Неверный формат URL",
            versions: "Требуется хотя бы одна версия",
            launchers: "Требуется хотя бы один лаунчер"
          }
        },
        cancel: "Отмена",
        create: {
          loading: "Создание...",
          default: "Создать мод"
        },
        langDataError: "Ошибка при загрузке языковых данных:",
      },
      noMods: "Моды не найдены",
      getStarted: "Начните с создания нового мода.",
      fetch: {
        error: 'Ошибка при получении документации:'
      },
      "delete": {
        link: "Удалить",
        confirm: "Вы уверены, что хотите удалить этот мод?"
      },
      toast: {
        delete: {
          success: {
            title: "Мод удален",
            description: "Мод был успешно удален."
          },
          error: {
            console: "Ошибка при удалении мода:",
            fallback: "Не удалось удалить мод",
            title: "Ошибка",
            description: "Произошла ошибка при удалении мода."
          }
        },
        edit: {
          success: {
            title: "Успех",
            description: "Мод успешно обновлен"
          }
        },
        add: {
          fallback: "Не удалось создать мод",
          success: {
            title: "Успех",
            description: "Мод успешно создан"
          },
          console: "Ошибка при создании мода:",
          error: {
            title: "Ошибка",
            description: "Не удалось создать мод"
          }
        }
      },
      noDesc: "Описание отсутствует",
      docs: {
        link: "Документация"
      },
      edit: {
        link: "Редактировать",
        title: "Редактировать мод",
        langDataError: "Ошибка при загрузке языковых данных:",
        notFound: "Мод не найден",
        failFetch: "Не удалось получить мод",
        unknownError: "Произошла неизвестная ошибка",
        form: {
          errors: {
            name: "Название обязательно",
            description: "Описание на английском (США) обязательно",
            curseforge: "Ссылка на CurseForge обязательна",
            versions: "Все поля версий должны быть заполнены",
            launchers: "Должен быть выбран хотя бы один лаунчер"
          }
        },
        modInfo: "Информация о моде",
        editModInfo: "Редактировать информацию о моде.",
        name: "Название",
        description: {
          title: "Описание",
          required: "Описание на английском (США) обязательно."
        },
        optional: "Опционально",
        versions: {
          title: "Версии",
          add: "Добавить версию",
          remove: "Удалить"
        },
        icon: "URL иконки",
        launchers: "Лаунчеры",
        cancel: "Отмена",
        update: "Обновить мод"
      }
    },
    docs: {
      access: {
        title: "Доступ запрещен",
        description: "У вас нет разрешения на доступ к этой странице."
      },
      title: "Документация",
      description: "Просматривайте и читайте документацию для модов Minecraft",
      create: {
        link: "Создать документацию",
        tab: "Создать новую",
        content: {
          title: "Нет доступных модов",
          description: "У всех модов уже есть документация или у вас нет разрешения на создание документации для любого мода."
        },
        title: "Создать документацию"
      },
      published: "Опубликовано",
      pending: "Ожидает",
      noDocs: {
        title: "Нет доступной документации",
        description: "Пока нет опубликованных страниц документации."
      },
      noPending: {
        title: "Нет ожидающей документации",
        superAdmin: "Нет страниц документации, ожидающих одобрения",
        rest: "У вас нет ожидающих страниц документации."
      },
      user: {
        noDocs: {
          title: "Нет доступной документации",
          description: "Пока нет опубликованных страниц документации."
        }
      },
      card: {
        pending: "Ожидает одобрения",
        view: "Просмотр",
        edit: "Редактировать"
      },
      add: {
        title: "Создать новую документацию",
        description: "Создайте всестороннюю документацию для мода Minecraft",
        noMods: {
          title: "Нет доступных модов",
          description: "Нет модов, доступных для создания документации. Либо у всех модов уже есть документация, либо у вас нет разрешения на создание документации для любого мода."
        },
        card: {
          title: "Основная информация",
          description: "Предоставьте основную информацию о документации.",
          descriptionLink: "Посмотреть наше руководство по документации",
          content: {
            modSelect: "Выберите мод",
            modSelectDesc: "Выберите мод, для которого вы хотите создать документацию",
            noDesc: "Описание отсутствует",
            form: {
              title: {
                title: "Заголовок",
                placeholder: "Введите заголовок документации",
                description: "Заголовок вашей документации (требуется английский США)"
              },
              description: {
                title: "Описание",
                placeholder: "Введите описание документации",
                description: "Краткое описание вашей документации (требуется английский США)"
              },
              coverImage: {
                title: "URL обложки (Опционально)",
                description: "Предоставьте URL для обложки вашей документации"
              },
              tabs: {
                preview: {
                  title: "Предпросмотр",
                  content: {
                    title: "Предпросмотр",
                    description: "Предпросмотр того, как будет выглядеть ваша документация",
                    form: {
                      title: "Заголовок документации",
                      description: "Описание документации будет отображаться здесь."
                    },
                    section: "раздел",
                    article: "статья",
                    modSelect: {
                      title: "Выберите мод",
                      description: "Выберите мод для предпросмотра вашей документации"
                    }
                  }
                },
                information: {
                  title: "Информация",
                  content: {
                    title: "Информация",
                    description: "Важная информация о создании документации",
                    approval: {
                      title: "Требуется одобрение",
                      description: "Документация, созданная редакторами и администраторами, требует одобрения суперадминистратора, прежде чем стать общедоступной. Откройте тикет, чтобы запросить это."
                    },
                    after: {
                      title: "После создания:",
                      list: {
                        one: "Вы будете перенаправлены в редактор документации",
                        two: "Раздел и статья по умолчанию будут созданы автоматически",
                        three: "Вы можете добавить дополнительные разделы и статьи по мере необходимости",
                        four: "Вы можете загружать изображения и добавлять пользовательские компоненты",
                        five: "Вы можете предварительно просмотреть вашу документацию перед отправкой на одобрение. (Она должна быть сохранена перед предпросмотром)"
                      }
                    },
                    create: {
                      loading: "Создание...",
                      default: "Создать документацию"
                    }
                  }
                }
              }
            }
          }
        },
        fetch: {
          mods: "Не удалось получить моды",
          documentation: "Не удалось получить документацию"
        },
        success: {
          title: "Документация создана",
          description: "Ваша документация была успешно создана."
        },
        error: {
          fetching: {
            mods: {
              console: "Ошибка при получении модов:",
              toast: {
                title: "Ошибка",
                description: "Не удалось загрузить моды. Пожалуйста, попробуйте снова."
              }
            }
          },
          creating: {
            failed: "Не удалось создать документацию",
            error: {
              console: "Ошибка при создании документации:",
              toast: {
                title: "Ошибка",
                description: "Не удалось создать документацию. Пожалуйста, попробуйте снова."
              }
            }
          }
        }
      }
    }
  }
}